var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"threejsContainer"},[_c('div',{staticClass:"containerTitle"},[_vm._v("1-1.fire"),_c('button',{on:{"click":_vm.changeMe}},[_vm._v("报警开关")]),_c('button',{on:{"click":_vm.changeTwinklingStyle}},[_vm._v("闪烁方式改变")])]),_c('div',{ref:"container",staticClass:"containerBody"})])
}
var staticRenderFns = []

export { render, staticRenderFns }